import { ENDPOINTS } from 'src/constants/endpoints'

import type { IPortfolioNewsCompaniesResponseDTO } from 'src/app/home/pages/portfolio-news/domain/contracts/portfolio-news'
import { http } from 'src/interfaces/http'

export const getPortfolioNewsCompanies =
  async (): Promise<IPortfolioNewsCompaniesResponseDTO> => {
    const { data } = await http.get<IPortfolioNewsCompaniesResponseDTO>(
      ENDPOINTS.hanwha.portfolioNewsCompanies,
    )
    return data
  }
